<template>
    <div>
        <div v-if="!loading">
            <FilterModal :show="showFilterModal" :ma-options="ma_list" :geo-options="geo_list" :os-options="os_list"
                :initial-filters="filter_state" @close="showFilterModal = false" @clear="clearAllFilters"
                @apply="handleApplyFilters" />

            <div class="add-btn" @click="go_to_add">
                <div class="add-btn-l">
                    <b-button id="plus-btn" size="sm" variant="outline-primary" class="mb-2">
                        <b-icon font-scale="3" icon="plus" aria-label="Help"></b-icon>
                    </b-button>
                </div>
                <div class="add-btn-l">
                    <div class="add-btn-l-i">
                        Add New Group
                    </div>
                </div>
            </div>
            <div class="flex flex-row justify-content-between search-filter-container">
                <div class="filter-form-container d-flex justify-content-between align-items-center">
                    <form @submit.prevent>
                        <h5>Search</h5>
                        <label class="search-label">By Campaign ID:</label>
                        <input ref="filter-sl-id" class="def filter-select filter-input" v-model="filterForm.camp">
                    </form>
                </div>
                <div class="filter-form-container filter-column">
                    <b-button size="sm" variant="outline-secondary" @click="showFilterModal = true">
                        <b-icon icon="funnel-fill"></b-icon> Filters
                    </b-button>
                    <div class="active-filters mb-3" v-if="hasActiveFilters">
                        <span v-for="tag in activeFilterTags" :key="tag.key" class="filter-tag"
                            @click="removeFilter(tag)">
                            {{ tag.label }}
                            <b-icon icon="x" class="ml-1" />
                        </span>
                    </div>
                </div>
            </div>
            <ResizableDataTable v-if="!loading && rows_data.length > 0" :rows_data="rows_data" :fields="fields"
                :show_c.sync="show_col" :delete="deleteGroup" :nonIntFields="nonIntFields" :edit_label="'Edit Group'"
                :show_columns_name="'dsp-automator'" :dateFileds="dateFields">
            </ResizableDataTable>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import ResizableDataTable from '../../components/shared/ResizableDataTable.vue';
import FilterModal from '../../components/shared/FilterModal.vue';
export default {
    components: {
        ResizableDataTable,
        FilterModal
    },
    data() {
        return {
            loading: false,
            filterForm: {
                camp: null
            },
            filter_value: '',
            ma_list: [],
            origin_list: [],
            rows_data: [],
            show_col: {
                id: true,
                name: true,
                csm_name: true,
                actions: true
            },
            fields: [],
            nonIntFields: [],
            dateFields: [],
            geo_list: [],
            os_list: [],
            showFilterModal: false,
            filter_state: {
                ma: [],
                geo: [],
                os: []
            },
        }
    },
    async created() {
        this.loading = true;
        await this.getData();
        this.fields = [
            {
                name: 'name',
                label: 'Group Name',
                sortable: true,
                toggle_column: 1,
                show_c: true
            },
            {
                name: 'geo',
                label: 'Geo',
                sortable: true,
                toggle_column: 2,
                show_c: true
            },
            {
                name: 'os',
                label: 'OS',
                sortable: true,
                toggle_column: 3,
                show_c: true
            },
            {
                name: 'ma_name',
                label: 'Marketing Analyst',
                sortable: true,
                toggle_column: 4,
                show_c: true
            },
            {
                name: 'description',
                label: 'Description',
                sortable: true,
                toggle_column: 5,
                show_c: true
            },
            {
                name: 'last_edit',
                label: 'Last Edit',
                sortable: true,
                toggle_column: 6,
                show_c: true
            },
            {
                name: 'last_dsp_update',
                label: 'Last DSP Update',
                sortable: true,
                toggle_column: 7,
                show_c: true
            }
        ]
        this.nonIntFields = ['name', 'geo', 'os', 'ma_name', 'description']
        this.dateFields = ['last_edit', 'last_dsp_update']
        for (const field of this.fields) {
            this.show_col[field.toggle_column] = true;
        }
        this.loading = false;
    },
    watch: {
        ["filterForm.camp"](val) {
            this.searchByCamp()
        }
    },
    methods: {
        async getData() {
            try {
                /* add edit links */
                let res = await this.$http.get(this.resources.Management.getSchedulerList)
                if (res.data.res !== 'OK') {
                    this.notifyError('Can\'t fetch data');
                    this.loading = false;
                    return;
                }

                console.log(res.data.combined_data.scheduler_list);
                for (const k in res.data.combined_data.scheduler_list) {
                    res.data.combined_data.scheduler_list[k].edit = '/media-analyst/dsp-schedule/edit?id=' + res.data.combined_data.scheduler_list[k].id
                }
                this.origin_list = res.data.combined_data.scheduler_list;
                this.rows_data = this.origin_list;

                this.ma_list = res.data.combined_data.ma_list.map(row => {
                    return {
                        value: row.media_analyst_manager,
                        text: row.media_analyst_manager
                    }
                });
                this.ma_list.push({
                    value: 'None',
                    text: 'None'
                });
                this.geo_list = [...new Set(this.origin_list.map(item => item.geo))].filter(Boolean).map(val => ({ value: val, text: val }));
                this.os_list = [...new Set(this.origin_list.map(item => item.os))].filter(Boolean).map(val => ({ value: val, text: val }));
            } catch (err) {
                console.log(err);
            }
        },
        go_to_add() {
            window.location.href = '/media-analyst/dsp-schedule/edit?id=0';
        },
        async clearTableRowFilter() {
            this.selected_list = [];
            this.filter_value = null;
            this.current_list = [];
            this.rows_data = this.origin_list;
        },
        async deleteGroup(row) {
            if (!confirm(`Are you sure you want to delete this group ${row.name} ? `)) {
                return;
            }
            this.loading = true;
            const id = row.id;
            console.log(id);
            console.log(this.resources.Management.deleteScheduler(id));
            try {
                const res = await this.$http.delete(this.resources.Management.deleteScheduler(id), {
                    id: id
                });
                if (res.body.res.includes('OK')) {
                    this.notifySuccess('Group has been deleted');
                    await this.getData();
                }

                this.loading = false;
            } catch (err) {
                console.log(err);
                this.notifyError('Group can\'t be deleted due to an error.');
            }
        },
        async searchByCamp() {
            let camp = this.filterForm.camp;
            if (camp === null || camp === '') {
                this.rows_data = this.origin_list;
                return;
            }
            let filtered_rows = []
            for (const k in this.rows_data) {
                let lists = ['bucksense_cmps_str', 'kayzen_cmps_str']
                for (const l of lists) {
                    if (this.rows_data[k][l].includes(camp)) {
                        filtered_rows.push(this.rows_data[k]);
                        break;
                    }
                }
            }

            this.rows_data = filtered_rows;
        },
        handleApplyFilters(newFilters) {
            this.filter_state = newFilters;
            this.showFilterModal = false;
            this.rows_data = this.origin_list.filter(row => {
                const matchMa = this.filter_state.ma.length === 0 || this.filter_state.ma.includes(row.ma_name);
                const matchGeo = this.filter_state.geo.length === 0 || this.filter_state.geo.includes(row.geo);
                const matchOs = this.filter_state.os.length === 0 || this.filter_state.os.includes(row.os);
                return matchMa && matchGeo && matchOs;
            });
        },
        clearAllFilters() {
            this.filter_state = {
                ma: [],
                geo: [],
                os: []
            };
            this.rows_data = this.origin_list;
            this.showFilterModal = false;
        },
        removeFilter(tag) {
            this.filter_state[tag.type] = this.filter_state[tag.type].filter(v => v !== tag.value);
            this.handleApplyFilters(this.filter_state);
        },
    },
    computed: {
        hasActiveFilters() {
            return (
                this.filter_state.ma.length > 0 ||
                this.filter_state.geo.length > 0 ||
                this.filter_state.os.length > 0
            );
        },
        activeFilterTags() {
            const tags = [];
            this.filter_state.ma.forEach(val => {
                tags.push({ key: `ma:${val}`, label: `Analyst: ${val}`, type: 'ma', value: val });
            });
            this.filter_state.geo.forEach(val => {
                tags.push({ key: `geo:${val}`, label: `GEO: ${val}`, type: 'geo', value: val });
            });
            this.filter_state.os.forEach(val => {
                tags.push({ key: `os:${val}`, label: `OS: ${val}`, type: 'os', value: val });
            });
            return tags;
        }
    },
}
</script>
<style scoped>
.add-btn {
    cursor: pointer;
    display: inline-block;
}

.add-btn-l {
    display: inline-block;
    vertical-align: top;
    padding-top: 15px;
    padding-right: 10px;
}

.add-btn-l-i {
    padding-top: 12px;
}

.filter-select {
    width: 100%;
}

.search-label {
    margin-bottom: 5px;
}

.filter-input {
    height: 30px;
}

.search-filter-container {
    gap: 10px;
    width: 55%;
}

.filter-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.filter-tag {
    display: inline-flex;
    align-items: center;
    background-color: #e0e0e0;
    padding: 4px 8px;
    border-radius: 12px;
    margin-right: 5px;
    margin-bottom: 5px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.filter-tag:hover {
    background-color: #ccc;
}
</style>